import React from 'react';
import Button from '../controls/Button';
import { PlusIcon } from '@heroicons/react/24/outline';
import SnowflakeIcon from '../../assets/images/icons/Snowflake_icon.svg';

interface EmptyAccountsStateProps {
  onAddAccount: () => void;
}

/**
 * Display when user has no Snowflake accounts
 *
 * Features:
 * - Friendly message: "No Snowflake accounts connected"
 * - Subtext: "Add your first Snowflake account to get started"
 * - "Add Account" button
 * - Snowflake icon
 *
 * @param onAddAccount - Callback to open add account dialog
 */
export function EmptyAccountsState({ onAddAccount }: EmptyAccountsStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      {/* Icon */}
      <div className="mb-6">
        <img src={SnowflakeIcon} alt="Snowflake" className="h-20 w-20 opacity-40" />
      </div>

      {/* Message */}
      <div className="text-center mb-8 max-w-md">
        <h3 className="text-xl font-semibold text-gray-900 mb-2">No Snowflake accounts connected</h3>
        <p className="text-sm text-gray-600">
          Add your first Snowflake account to get started with deploying solutions and managing your data operations.
        </p>
      </div>

      {/* Add Account Button */}
      <Button intent="primary" size="large" onClick={onAddAccount}>
        <PlusIcon className="w-5 h-5 mr-2" />
        Add Account
      </Button>

      {/* Additional Help Text */}
      <div className="mt-8 text-center max-w-lg">
        <p className="text-xs text-gray-500">
          You&apos;ll need your Snowflake account identifier and appropriate permissions to add an account. We&apos;ll
          guide you through the setup process.
        </p>
      </div>
    </div>
  );
}
